import { Link } from "react-router-dom";
import { Check } from "lucide-react";

export const JourneyPath = ({ stations, currentIndex = 0, nextAction, compact = false, onOlive = false }) => {
  const line = onOlive ? "border-sage-400" : "border-sage-400";
  const text = onOlive ? "text-cream-50" : "text-ink-900";
  const sub = onOlive ? "text-cream-50/80" : "text-ink-500";
  return (
    <ol className={`relative ml-3 border-l-2 ${line}`} data-testid="care-journey-path">
      {stations.map((s, i) => {
        const n = i + 1;
        const done = currentIndex > n;
        const current = currentIndex === n;
        let node = `${onOlive ? "bg-olive-900 border-sage-400" : "bg-cream-50 border-sage-400"}`;
        if (done) node = onOlive ? "bg-cream-50 border-cream-50 text-olive-900" : "bg-olive-900 border-olive-900 text-cream-50";
        if (current) node = onOlive ? "bg-cream-50 border-cream-50 ring-4 ring-cream-50/30" : "bg-olive-900 border-olive-900 ring-4 ring-olive-900/20";
        return (
          <li key={s.key || s.label} className={`relative pl-8 ${compact ? "pb-6" : "pb-10"} last:pb-0`} data-testid={`journey-station-${n}`} aria-current={current ? "step" : undefined}>
            <span className={`absolute -left-[13px] top-1 flex h-6 w-6 items-center justify-center rounded-full border-2 ${node}`} aria-hidden="true">
              {done && <Check className="h-4 w-4" strokeWidth={3} />}
            </span>
            <h3 className={`font-serif ${compact ? "text-lg" : "text-xl sm:text-2xl"} font-semibold ${text}`}>
              <span className={`${sub} mr-2 font-sans text-base font-normal`}>{n}.</span>{s.label}
            </h3>
            {s.body && <p className={`mt-1.5 max-w-[60ch] ${compact ? "text-sm" : "text-base"} ${current && !onOlive ? "text-ink-900" : sub}`}>{s.body}</p>}
            {current && nextAction && (
              <div className={`mt-4 max-w-md border p-4 confirm-pop ${onOlive ? "border-cream-50/40 bg-cream-50 text-ink-900" : "border-sage-400 bg-cream-100"}`} data-testid="journey-next-action">
                <p className="text-sm text-ink-500">Your next step</p>
                <p className="mt-0.5 font-serif text-lg font-semibold text-ink-900">{nextAction.label}</p>
                {nextAction.description && <p className="mt-1 text-sm text-ink-900">{nextAction.description}</p>}
                {nextAction.href && nextAction.available !== false && (
                  <Link to={nextAction.href} className="btn-primary mt-3 w-full sm:w-auto" data-testid="journey-next-action-button">{nextAction.label}</Link>
                )}
                
              </div>
            )}
          </li>
        );
      })}
    </ol>
  );
};
